export default __webpack_public_path__ + "static/media/05AW1SEP66.d5fa1ed6.jpg";